/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TimeGroupingFrequency {
    Monthly = 1,
    Quarterly = 2,
    Yearly = 3,
}

